<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="documentData"
      table-title="Documents"
      :fields="[{ header: 'Name', prop: 'name', hideByDefault: false }, { header: 'Code', prop: 'code', hideByDefault: false }]"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    >
      <div slot="icons" slot-scope="maiScope" class="btn btn-primary" data-toggle="tooltip" title="Download" @click="popup(maiScope.item)">
        <i class="fa fa-download"></i>
      </div>
    </vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  import event from '../../../../event'
  export default {
    name: 'DocumentSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    computed: {
      documentData () {
        return this.tableData.filter(data => data.category !== 'REPORT')
      }
    },
    data () {
      return {
        loading: false,
        entityName: 'document',
        editEntityScreen: 'Admin - Edit/View Document',
        active: null,
        filteredTableData: []
      }
    },
    methods: {
      popup (item) {
        this.active = item
      },
      notifyResults (succeeded) {
        if (succeeded) {
          event.$emit('toast', { type: 'success', message: `Search successful` })
        } else {
          event.$emit('toast', { type: 'error', message: 'An error occurred; please try again or contact support' })
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// DocumentSearchResults.vue?350eb66a